var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/hrgs/master/FormBuilderEnum';
import ApiService from '@/core/services/ApiService';
import { ElMessage } from 'element-plus';
import { swalAlertError } from '@/core/helpers/sweet-alert';
import { Pagination } from '@/core/enums/Pagination';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/forms`
};
let FormBuilderModule = class FormBuilderModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.formBuilderList = [];
        this.loading = false;
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1
        };
        this.filter = {
            title: '',
            code: '',
            scheme: ''
        };
        this.orderBy = null;
    }
    // *GETTERS
    get getFormBuilderList() {
        return this.formBuilderList;
    }
    get getFormBuilderListLoading() {
        return this.loading;
    }
    get getFormBuilderListPagination() {
        return this.pagination;
    }
    // *MUTATIONS
    [_a = Mutations.SET_FORM_BUILDER_LIST](data) {
        this.formBuilderList = data;
    }
    [_b = Mutations.SET_FORM_BUILDER_LIST_LOADING](data) {
        this.loading = data;
    }
    [_c = Mutations.SET_FORM_BUILDER_LIST_PAGINATION](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize)
        };
    }
    [_d = Mutations.SET_FILTER](data) {
        this.filter = Object.assign(Object.assign({}, this.filter), data);
    }
    [_e = Mutations.CLEAR_FILTER]() {
        this.filter = {
            code: '',
            title: '',
            scheme: ''
        };
    }
    [_f = Mutations.SET_ORDER](data) {
        this.orderBy = data;
    }
    // *start: ACTION
    [_g = Actions.GET_LIST](payload) {
        var _r, _s, _t, _u;
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const filter = `SearchValues=${((_r = this.filter) === null || _r === void 0 ? void 0 : _r.code) || ''}&SearchValues=${((_s = this.filter) === null || _s === void 0 ? void 0 : _s.title) || ''}`;
        const params = Object.assign(Object.assign(Object.assign(Object.assign({ ver: 'v1' }, ((payload === null || payload === void 0 ? void 0 : payload.isTemplate) && {
            IsTemplate: payload === null || payload === void 0 ? void 0 : payload.isTemplate
        })), (((_t = this.filter) === null || _t === void 0 ? void 0 : _t.scheme) && {
            schemeId: (_u = this.filter) === null || _u === void 0 ? void 0 : _u.scheme
        })), { pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO }), (this.orderBy && {
            orderBy: this.orderBy
        }));
        this.context.commit(Mutations.SET_FORM_BUILDER_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}?${filter}&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_FORM_BUILDER_LIST, resData.data);
                this.context.commit(Mutations.SET_FORM_BUILDER_LIST_PAGINATION, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: resData.totalRecords
                });
                resolve(resData.data);
            })
                .catch((error) => {
                swalAlertError('Failed get Form Builder list.', 'Close');
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_FORM_BUILDER_LIST_LOADING, false);
            });
        });
    }
    [_h = Actions.GET_DETAIL](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content;
                resolve(data);
            })
                .catch((error) => {
                swalAlertError('Failed get Form Builder details.', 'Close');
                reject(error);
            });
        });
    }
    [_j = Actions.POST_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload.data;
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    swalAlertError(res.data.result.message, 'Close');
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    this.context.dispatch(Actions.GET_LIST);
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                swalAlertError('Failed create Form Builder.', 'Close');
                reject(_response);
            });
        });
    }
    [_k = Actions.UPDATE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload.data;
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    swalAlertError(res.data.result.message, 'Close');
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    this.context.dispatch(Actions.GET_LIST);
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                swalAlertError('Failed update Form Builder.', 'Close');
                reject(_response);
            });
        });
    }
    [_l = Actions.DELETE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    swalAlertError(res.data.result.message, 'Close');
                    reject();
                }
                else {
                    this.context.dispatch(Actions.GET_LIST);
                    resolve(res.data.statusCode);
                }
            })
                .catch((response) => {
                swalAlertError('Failed delete Form Builder.', 'Close');
                reject(response);
            });
        });
    }
    [_m = Actions.GET_CODE_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const url = `${API_URLS.url}/${employeeID}/codes?`;
        const params = Object.assign(Object.assign({ ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO }, ((payload === null || payload === void 0 ? void 0 : payload.formTypeId) && { FormTypeId: payload === null || payload === void 0 ? void 0 : payload.formTypeId })), ((payload === null || payload === void 0 ? void 0 : payload.formMethodId) && { FormMethodId: payload === null || payload === void 0 ? void 0 : payload.formMethodId }));
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                swalAlertError('Failed get Form Builder list.', 'Close');
                reject(error);
            });
        });
    }
    [_o = Actions.GET_TYPE_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const url = `${API_URLS.url}/${employeeID}/types?`;
        const params = {
            ver: 'v1',
            pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE,
            pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                swalAlertError('Failed get Form Builder list.', 'Close');
                reject(error);
            });
        });
    }
    [_p = Actions.GET_METHOD_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const url = `${API_URLS.url}/${employeeID}/methods?`;
        const params = {
            ver: 'v1',
            pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE,
            pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                swalAlertError('Failed get Form Builder list.', 'Close');
                reject(error);
            });
        });
    }
    [_q = Actions.GET_FIELD_TYPE_LIST](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const url = `${API_URLS.url}/${employeeID}/fieldtypes?`;
        const params = {
            ver: 'v1',
            pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE,
            pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                swalAlertError('Failed get Form Builder list.', 'Close');
                reject(error);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _f, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _g, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _h, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _j, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _k, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _l, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _o, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _p, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], FormBuilderModule.prototype, _q, null);
FormBuilderModule = __decorate([
    Module
], FormBuilderModule);
export default FormBuilderModule;
